import React, { useEffect, useState, useContext } from "react";
import BannerSection from "../inc/BannerSection";
import Form from "../inc/Form";
import Banner from "../images/banner.jpg";
import Functions from "../../utility/services/Functions";
import ApiService from "../../utility/services/ApiService";
import { AuthContext } from "../../utility/services/AuthContext";
import Contact from "../inc/Form";
import ContactIMG from "../images/newimg/contact.png";
import { trackScreenView, getUserTrackingParams } from "../../utility/services/analyticsService";

const ContactUs = () => {
  const [content, setContent] = useState("");

  const { setLoading, user } = useContext(AuthContext);
  const { consoleService } = Functions();
  const { get_web_content_details } = ApiService();

  useEffect(() => {
    trackScreenView("contact_us_screen", { screen_name: "Contact Us", ...getUserTrackingParams(user) });
    get_initial_details();
  }, []);

  async function get_initial_details() {
    try {
      setLoading(true);
      const res = await get_web_content_details();
      if (res.status === 1) {
        if (res.data && res.data.length > 0 && res.data[0]?.contact_us_header) {
          setContent(res.data[0].contact_us_header);
        }
        setLoading(false);
      } else {
        consoleService("error in get_initial_details fun =- ", res.message);
      }
    } catch (err) {
      consoleService("error in get_initial_details fun = ", err);
    }
  }
  return (
    <>
      <BannerSection banner={Banner} name={"Home"} title={"Contact Us"} />
      <section id="contactus" className="py-5 contactus">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-4">
              <p className="text-white">
                We value your feedback, questions, and inquiries. Our dedicated
                team is here to assist you and ensure that your experience with
                us is as smooth and enjoyable as possible.
              </p>
              <img
                src={ContactIMG}
                alt=""
                className="img-fluid d-none d-md-block"
              />
            </div>
            <div className="col-md-8">
              <Contact />
            </div>
          </div>
        </div>
        <div className="mobileContact d-block d-sm-none d-lg-none d-xl-none d-md-none">
          <img src={ContactIMG} alt="" className="img-fluid " />
        </div>
      </section>
    </>
  );
};

export default ContactUs;
